import { formatarData } from 'src/app/core/utils/utilities';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EngateDesengateService } from 'src/app/services/EngateDesengateService/engateDesengate.service';
import Swal from 'sweetalert2';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

@Component({
  selector: 'app-modal-selecao-desengate',
  templateUrl: './modal-selecao-desengate.component.html',
  styleUrls: ['./modal-selecao-desengate.component.scss']
})
export class ModalSelecaoDesengateComponent implements OnInit {
  dataToEmit: any = {};
  loader: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private engateDesengateService: EngateDesengateService,
    public dialogRef: MatDialogRef<ModalSelecaoDesengateComponent>,
    public swalAlert: SwalAlertService
  ) {}

  ngOnInit(): void {
    this.activateRoute();
  }

  tableData: any[] = [];

  tableColumns = [
    {
      header: 'Nº Agendamento',
      key: 'FK_AGND',
      type: 'text'
    },
    {
      header: 'Motorista',
      key: 'NM_MTRT',
      type: 'text'
    },
    {
      header: 'Data Desengate',
      key: 'DT_ENGT_DSGT',
      type: 'text'
    },
    {
      header: 'Placa',
      key: 'TX_PLCA_CRRT',
      type: 'text'
    },
    {
      header: '',
      key: 'selecionar',
      type: 'checkbox',
      action: (item: any) => this.selectDesengate(item)
    }
  ];

  getDesengates(params: any): void {
    this.loader = true;
    this.engateDesengateService
      .GetCarretasNaoEngatadasInfoByIdOrPlacaOrAgendamento(params)
      .subscribe({
        next: res => {
          const data = res;
          if (!data || (!data.FK_CRRT_1 && !data.FK_CRRT_2 && !data.FK_CRRT_3)) {
            this.loader = false;
            this.swalAlert.showAlert(
              'Atenção',
              'Nenhuma carreta relacionada a este agendamento ou placa está disponível para engate.',
              'warning',
              true,
              false,
              undefined,
              () => {
                this.dialogRef.close();
              }
            );
            return;
          }
          if (data.FK_CRRT_1) {
            this.tableData.push({
              FK_AGND: data.FK_AGND ?? '---',
              FK_GATE_ENTR: data.FK_GATE_ENTR,
              NM_MTRT: data.NM_MTRT,
              DT_ENGT_DSGT: formatarData(data.DT_ENGT_DSGT),
              TX_PLCA_CRRT: data.TX_PLCA_CRRT1,
              PK_ENGT_DSGT: data.PK_ENGT_DSGT,
              FK_CRRT: data.FK_CRRT_1,
              FK_CMNH: data.FK_CMNH,
              selecionar: false
            });
          }
          if (data.FK_CRRT_2) {
            this.tableData.push({
              FK_AGND: data.FK_AGND ?? '---',
              FK_GATE_ENTR: data.FK_GATE_ENTR,
              NM_MTRT: data.NM_MTRT,
              DT_ENGT_DSGT: formatarData(data.DT_ENGT_DSGT),
              TX_PLCA_CRRT: data.TX_PLCA_CRRT2,
              PK_ENGT_DSGT: data.PK_ENGT_DSGT,
              FK_CRRT: data.FK_CRRT_2,
              FK_CMNH: data.FK_CMNH,
              selecionar: false
            });
          }
          if (data.FK_CRRT_3) {
            this.tableData.push({
              FK_AGND: data.FK_AGND ?? '---',
              FK_GATE_ENTR: data.FK_GATE_ENTR,
              NM_MTRT: data.NM_MTRT,
              DT_ENGT_DSGT: formatarData(data.DT_ENGT_DSGT),
              TX_PLCA_CRRT: data.TX_PLCA_CRRT3,
              PK_ENGT_DSGT: data.PK_ENGT_DSGT,
              FK_CRRT: data.FK_CRRT_3,
              FK_CMNH: data.FK_CMNH,
              selecionar: false
            });
          }
          this.loader = false;
        },
        error: err => {
          this.dialogRef.close();
          this.swalAlert.handleError(
            err,
            'Atenção',
            'Nenhuma carreta relacionada a este agendamento ou placa está disponível para engate.',
            'warning'
          );
          this.loader = false;
        }
      });
  }

  selectDesengate(item: any) {
    const itemSelecionado = this.tableData.find(
      x => x.FK_CRRT === item.FK_CRRT
    );
    this.tableData = this.tableData.map((x: any) => {
      return {
        ...x,
        selecionar:
          x.FK_CRRT === item.FK_CRRT
            ? !itemSelecionado.selecionar
            : x.selecionar
      };
    });

    const carretasSelecionadas = this.tableData.filter(
      (x: any) => x.selecionar
    );
    this.dataToEmit = carretasSelecionadas;
  }

  emitDesengate(): void {
    this.dialogRef.close(this.dataToEmit);
  }

  onCancelar(): void {
    this.dialogRef.close();
  }

  activateRoute(): void {
    const FK_AGND = this.data.FK_AGND;
    const TX_PLCA_CRRT = this.data.TX_PLCA_DSGT;
    if (FK_AGND || TX_PLCA_CRRT) {
      const params = {
        FK_AGND,
        TX_PLCA_CRRT
      };
      this.getDesengates(params);
    }
  }
}
